import { debugLog } from '../debugLog';
export const findMyAvatarUrlFrom = (channelSessionCode, positionChannelDetail)=>{
    const found = positionChannelDetail.channel_sessions.find((channelSession)=>channelSession.channel_session_code === channelSessionCode);
    if (found === undefined) {
        debugLog(`[ findMyAvatarUrlFrom ] no channelSession was found from channelSessionCode = ${channelSessionCode}`);
        return undefined;
    }
    return found.avatar_info;
};
export const upsertMyAvatarInfo = (myAvatarInfoStr, positionChannelDetail)=>{
    try {
        const myAvatarInfo = JSON.parse(myAvatarInfoStr);
        positionChannelDetail.channel_sessions = positionChannelDetail.channel_sessions.map((channelSession)=>{
            if (channelSession.channel_session_code === myAvatarInfo.channel_session_code) {
                channelSession.avatar_info = myAvatarInfo;
                debugLog('[ upsertMyAvatarInfo ] myAvatarInfo updated at channelSessionCode = ' + channelSession.channel_session_code);
            }
            return channelSession;
        });
    } catch (e) {
        debugLog(`[ upsertMyAvatarInfo ] JSON.parse error = ${e}`);
    }
};
